'use client'

import { createContext, useContext, type ReactNode } from 'react'

/**
 * The partner brand the auth layout resolved from the request's host, handed
 * to the (client) sign-in forms beneath it. `isPartnerHost` is true only on a
 * white-label partner's domain; on SurveyThanks' own hosts the brand is ours.
 */
export type AuthBrand = { brandName: string; isPartnerHost: boolean }

const AuthBrandContext = createContext<AuthBrand>({ brandName: 'SurveyThanks', isPartnerHost: false })

export function AuthBrandProvider({ value, children }: { value: AuthBrand; children: ReactNode }) {
  return <AuthBrandContext.Provider value={value}>{children}</AuthBrandContext.Provider>
}

export function useAuthBrand(): AuthBrand {
  return useContext(AuthBrandContext)
}
